var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "schedule-manager" },
    [
      _c("div", { staticClass: "schedule-header" }, [
        _c("div", [
          _c("h5", { staticClass: "schedule-title" }, [
            _vm._v(_vm._s(_vm.$t("schedule.space.title"))),
          ]),
          _c("p", { staticClass: "schedule-subtitle" }, [
            _vm._v(_vm._s(_vm.$t("schedule.space.subtitle"))),
          ]),
        ]),
        !_vm.readonly
          ? _c(
              "div",
              { staticClass: "schedule-header-actions" },
              [
                _c(
                  "b-button",
                  {
                    attrs: { variant: "outline-primary", size: "sm" },
                    on: {
                      click: function ($event) {
                        return _vm.addRow()
                      },
                    },
                  },
                  [
                    _c("feather-icon", {
                      staticClass: "mr-50",
                      attrs: { icon: "PlusIcon", size: "16" },
                    }),
                    _c("span", { staticClass: "align-middle" }, [
                      _vm._v(_vm._s(_vm.$t("schedule.grid.add_row"))),
                    ]),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm.legacyIgnored > 0
        ? _c(
            "div",
            { staticClass: "schedule-legacy" },
            [
              _c("feather-icon", {
                staticClass: "mr-50",
                attrs: { icon: "AlertTriangleIcon", size: "16" },
              }),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t("schedule.space.legacy_ignored", {
                      n: _vm.legacyIgnored,
                    })
                  )
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.isRowEmpty
        ? _c(
            "div",
            { staticClass: "schedule-empty" },
            [
              _c("feather-icon", {
                staticClass: "text-primary mb-1",
                attrs: { icon: "ClockIcon", size: "28" },
              }),
              _c("p", { staticClass: "schedule-empty-title" }, [
                _vm._v(_vm._s(_vm.$t("schedule.grid.empty_title"))),
              ]),
              _c("p", { staticClass: "schedule-empty-hint" }, [
                _vm._v(_vm._s(_vm.$t("schedule.space.empty_hint"))),
              ]),
              !_vm.readonly
                ? _c(
                    "b-button",
                    {
                      staticClass: "mt-1",
                      attrs: { variant: "primary", size: "sm" },
                      on: {
                        click: function ($event) {
                          return _vm.addRow()
                        },
                      },
                    },
                    [
                      _c("feather-icon", {
                        staticClass: "mr-50",
                        attrs: { icon: "PlusIcon", size: "16" },
                      }),
                      _c("span", { staticClass: "align-middle" }, [
                        _vm._v(_vm._s(_vm.$t("schedule.grid.add_row"))),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _c("div", { staticClass: "schedule-scroll" }, [
            _c(
              "div",
              { staticClass: "schedule-table" },
              [
                _c(
                  "div",
                  { staticClass: "schedule-row schedule-row-head" },
                  [
                    _c("div", { staticClass: "schedule-legend" }),
                    _vm._l(_vm.weekDays, function (day) {
                      return _c(
                        "div",
                        {
                          key: "head-" + day,
                          staticClass: "schedule-cell schedule-head-cell",
                          class: { "is-weekend": _vm.isWeekend(day) },
                        },
                        [
                          _c("span", { staticClass: "head-short" }, [
                            _vm._v(_vm._s(_vm.dayShort(day))),
                          ]),
                          _c("span", { staticClass: "head-count" }, [
                            _vm._v(_vm._s(_vm.dayCountLabel(day))),
                          ]),
                        ]
                      )
                    }),
                    _c("div", { staticClass: "schedule-total-col" }, [
                      _vm._v(_vm._s(_vm.$t("schedule.weekly_total"))),
                    ]),
                    _c("div", { staticClass: "schedule-actions-col" }, [
                      _vm._v(_vm._s(_vm.$t("actions"))),
                    ]),
                  ],
                  2
                ),
                _vm._l(_vm.rows, function (row, rowIndex) {
                  return _c(
                    "div",
                    {
                      key: row.uid,
                      staticClass: "schedule-row schedule-row-body",
                    },
                    [
                      _c("div", { staticClass: "schedule-legend" }, [
                        _c("span", { staticClass: "legend-item" }, [
                          _vm._v(_vm._s(_vm.$t("schedule.grid.start"))),
                        ]),
                        _c("span", { staticClass: "legend-item" }, [
                          _vm._v(_vm._s(_vm.$t("schedule.grid.end"))),
                        ]),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.auto",
                                value: {
                                  content: _vm.$t(
                                    "schedule.space.capacity_hint"
                                  ),
                                  delay: { show: 300, hide: 100 },
                                },
                                expression:
                                  "{ content: $t('schedule.space.capacity_hint'), delay: { show: 300, hide: 100 } }",
                                modifiers: { auto: true },
                              },
                            ],
                            staticClass: "legend-item legend-capacity",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("schedule.space.capacity_label")
                                ) +
                                " "
                            ),
                            _c("feather-icon", {
                              attrs: { icon: "HelpCircleIcon", size: "12" },
                            }),
                          ],
                          1
                        ),
                        _c("span", { staticClass: "legend-meta" }),
                      ]),
                      _vm._l(_vm.weekDays, function (day) {
                        return _c(
                          "div",
                          {
                            key: row.uid + "-" + day,
                            staticClass: "schedule-cell",
                            class: {
                              "is-weekend": _vm.isWeekend(day),
                              "has-error": _vm.cellHasError(rowIndex, day),
                            },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: row.days[day].start,
                                  expression: "row.days[day].start",
                                },
                              ],
                              staticClass: "cell-input",
                              class: _vm.inputClass(rowIndex, day, "start"),
                              attrs: {
                                type: "time",
                                disabled: _vm.readonly,
                                "aria-label":
                                  _vm.$t("schedule.grid.start") +
                                  " — " +
                                  _vm.dayLong(day),
                              },
                              domProps: { value: row.days[day].start },
                              on: {
                                change: function ($event) {
                                  return _vm.onStartChange(row, day)
                                },
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return _vm.focusNextField($event)
                                },
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    row.days[day],
                                    "start",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: row.days[day].end,
                                  expression: "row.days[day].end",
                                },
                              ],
                              staticClass: "cell-input",
                              class: _vm.inputClass(rowIndex, day, "end"),
                              attrs: {
                                type: "time",
                                disabled: _vm.readonly,
                                "aria-label":
                                  _vm.$t("schedule.grid.end") +
                                  " — " +
                                  _vm.dayLong(day),
                              },
                              domProps: { value: row.days[day].end },
                              on: {
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return _vm.focusNextField($event)
                                },
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    row.days[day],
                                    "end",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: row.days[day].capacity,
                                  expression: "row.days[day].capacity",
                                },
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.auto",
                                  value: {
                                    content: _vm.$t(
                                      "schedule.space.capacity_hint"
                                    ),
                                    delay: { show: 500, hide: 100 },
                                  },
                                  expression:
                                    "{ content: $t('schedule.space.capacity_hint'), delay: { show: 500, hide: 100 } }",
                                  modifiers: { auto: true },
                                },
                              ],
                              staticClass: "cell-input cell-capacity",
                              class: _vm.inputClass(rowIndex, day, "capacity"),
                              attrs: {
                                type: "number",
                                min: "1",
                                max: "999",
                                step: "1",
                                disabled: _vm.readonly,
                                "aria-label":
                                  _vm.$t("schedule.space.capacity_label") +
                                  " — " +
                                  _vm.dayLong(day),
                              },
                              domProps: { value: row.days[day].capacity },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    row.days[day],
                                    "capacity",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("span", { staticClass: "cell-meta" }, [
                              _vm._v(_vm._s(_vm.cellMeta(rowIndex, day))),
                            ]),
                          ]
                        )
                      }),
                      _c("div", { staticClass: "schedule-total-col" }, [
                        _c("span", { staticClass: "row-total" }, [
                          _vm._v(_vm._s(_vm.rowTotals[rowIndex])),
                        ]),
                        _c("span", { staticClass: "row-days" }, [
                          _vm._v(_vm._s(_vm.rowDaysLabel(rowIndex))),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "schedule-actions-col" },
                        [
                          !_vm.readonly
                            ? [
                                _c("feather-icon", {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip.auto",
                                      value: {
                                        content: _vm.$t(
                                          "schedule.grid.replicate"
                                        ),
                                        delay: { show: 300, hide: 100 },
                                      },
                                      expression:
                                        "{ content: $t('schedule.grid.replicate'), delay: { show: 300, hide: 100 } }",
                                      modifiers: { auto: true },
                                    },
                                  ],
                                  staticClass: "cursor-pointer text-primary",
                                  attrs: { icon: "CopyIcon", size: "20" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openReplicate(rowIndex)
                                    },
                                  },
                                }),
                                _c("feather-icon", {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip.auto",
                                      value: {
                                        content: _vm.$t(
                                          "schedule.grid.duplicate_row"
                                        ),
                                        delay: { show: 300, hide: 100 },
                                      },
                                      expression:
                                        "{ content: $t('schedule.grid.duplicate_row'), delay: { show: 300, hide: 100 } }",
                                      modifiers: { auto: true },
                                    },
                                  ],
                                  staticClass: "cursor-pointer text-primary",
                                  attrs: { icon: "LayersIcon", size: "20" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.duplicateRow(rowIndex)
                                    },
                                  },
                                }),
                                _c("feather-icon", {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip.auto",
                                      value: {
                                        content: _vm.$t(
                                          "schedule.grid.remove_row"
                                        ),
                                        delay: { show: 300, hide: 100 },
                                      },
                                      expression:
                                        "{ content: $t('schedule.grid.remove_row'), delay: { show: 300, hide: 100 } }",
                                      modifiers: { auto: true },
                                    },
                                  ],
                                  staticClass: "cursor-pointer text-danger",
                                  attrs: { icon: "Trash2Icon", size: "20" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.confirmRemoveRow(rowIndex)
                                    },
                                  },
                                }),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm.rowMessages(rowIndex).length
                        ? _c(
                            "ul",
                            { staticClass: "schedule-row-messages" },
                            _vm._l(
                              _vm.rowMessages(rowIndex),
                              function (message, index) {
                                return _c(
                                  "li",
                                  { key: "msg-" + row.uid + "-" + index },
                                  [
                                    _c("feather-icon", {
                                      staticClass: "mr-25",
                                      attrs: {
                                        icon: "AlertCircleIcon",
                                        size: "13",
                                      },
                                    }),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.dayShort(message.day)) + ":"
                                      ),
                                    ]),
                                    _vm._v(" " + _vm._s(message.text) + " "),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                }),
                _c(
                  "div",
                  { staticClass: "schedule-row schedule-row-foot" },
                  [
                    _c("div", { staticClass: "schedule-legend" }, [
                      _vm._v(_vm._s(_vm.$t("schedule.day_total"))),
                    ]),
                    _vm._l(_vm.weekDays, function (day) {
                      return _c(
                        "div",
                        {
                          key: "foot-" + day,
                          staticClass: "schedule-cell schedule-foot-cell",
                          class: { "is-weekend": _vm.isWeekend(day) },
                        },
                        [_vm._v(" " + _vm._s(_vm.dayTotals[day]) + " ")]
                      )
                    }),
                    _c("div", { staticClass: "schedule-total-col" }, [
                      _vm._v(_vm._s(_vm.grandTotal)),
                    ]),
                    _c("div", { staticClass: "schedule-actions-col" }),
                  ],
                  2
                ),
              ],
              2
            ),
          ]),
      _c(
        "div",
        {
          staticClass: "schedule-status",
          class: { "is-invalid": _vm.hasErrors },
        },
        [
          _vm.hasErrors
            ? [
                _c("feather-icon", {
                  staticClass: "text-danger mr-50",
                  attrs: { icon: "AlertCircleIcon", size: "16" },
                }),
                _c("span", { staticClass: "text-danger" }, [
                  _vm._v(_vm._s(_vm.$t("schedule.grid.fix_errors"))),
                ]),
              ]
            : !_vm.isRowEmpty
            ? [
                _c("feather-icon", {
                  staticClass: "text-primary mr-50",
                  attrs: { icon: "InfoIcon", size: "16" },
                }),
                _c("span", [_vm._v(_vm._s(_vm.summaryLabel))]),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "b-modal",
        {
          attrs: {
            title: _vm.$t("schedule.grid.replicate_modal.title"),
            size: "md",
            centered: "",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-secondary" },
                      on: {
                        click: function ($event) {
                          _vm.replicate.open = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("schedule.grid.replicate_modal.cancel")
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "primary",
                        disabled:
                          !_vm.replicate.source ||
                          _vm.replicate.targets.length === 0,
                      },
                      on: { click: _vm.applyReplicate },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("schedule.grid.replicate_modal.confirm")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.replicate.open,
            callback: function ($$v) {
              _vm.$set(_vm.replicate, "open", $$v)
            },
            expression: "replicate.open",
          },
        },
        [
          _vm.replicateSourceOptions.length === 0
            ? _c("p", { staticClass: "text-danger mb-0" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("schedule.grid.replicate_modal.no_source")) +
                    " "
                ),
              ])
            : [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("schedule.grid.replicate_modal.source"),
                    },
                  },
                  [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.replicate.source,
                            expression: "replicate.source",
                          },
                        ],
                        staticClass: "form-control",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.replicate,
                              "source",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      _vm._l(_vm.replicateSourceOptions, function (option) {
                        return _c(
                          "option",
                          {
                            key: "src-" + option.day,
                            domProps: { value: option.day },
                          },
                          [_vm._v(" " + _vm._s(option.label) + " ")]
                        )
                      }),
                      0
                    ),
                  ]
                ),
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("schedule.grid.replicate_modal.targets"),
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "replicate-quick" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "flat-primary", size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.pickTargets("all")
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("schedule.grid.replicate_modal.all")
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "flat-primary", size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.pickTargets("weekdays")
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "schedule.grid.replicate_modal.weekdays"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "flat-primary", size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.pickTargets("weekend")
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "schedule.grid.replicate_modal.weekend"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "flat-primary", size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.pickTargets("none")
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("schedule.grid.replicate_modal.none")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "replicate-days" },
                      _vm._l(_vm.replicateTargetDays, function (day) {
                        return _c(
                          "label",
                          { key: "tgt-" + day, staticClass: "replicate-day" },
                          [
                            _c("input", {
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked:
                                  _vm.replicate.targets.indexOf(day) !== -1,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.toggleTarget(day)
                                },
                              },
                            }),
                            _c("span", [_vm._v(_vm._s(_vm.dayLong(day)))]),
                            _vm.isTargetFilled(day)
                              ? _c(
                                  "span",
                                  { staticClass: "replicate-day-tag" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "schedule.grid.replicate_modal.filled"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
                _c("label", { staticClass: "replicate-day" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.replicate.overwrite,
                        expression: "replicate.overwrite",
                      },
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.replicate.overwrite)
                        ? _vm._i(_vm.replicate.overwrite, null) > -1
                        : _vm.replicate.overwrite,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.replicate.overwrite,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.replicate,
                                "overwrite",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.replicate,
                                "overwrite",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.replicate, "overwrite", $$c)
                        }
                      },
                    },
                  }),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("schedule.grid.replicate_modal.overwrite"))
                    ),
                  ]),
                ]),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }